@if(form()){
<form [formGroup]="form()">
    <div class="grid grid-cols-1 md:grid-cols-4 gap-4 mb-4">
        <spike-field-wrapper label="Tipo Spedizione" icon="pi pi-truck">
        <p-select  
            [options]="courierTypeList"
            [checkmark]="true" 
            optionLabel="shortDescription" 
            optionValue="id"
            formControlName="courierType"
            [showClear]="true" 
            placeholder="seleziona corriere"
            id="courierType"
            inputId="courierType"
            class="w-full" />
        </spike-field-wrapper>
        @if(courierType() === 1 ){
        <spike-field-text label="Nome Corriere" formControlName="courierName" ></spike-field-text>
        } @else{
            <spike-field-select [initialValue]="organizationStore.getVehicle(form().controls['vehicleId']?.value??0)()" formControlName="vehicleId" label="Veicolo" selectKey="vehicleId" selectValue="shortDescription" listTitle="Seleziona veicolo" detailTitle="Dettaglio veicolo" placeholder="Seleziona veicolo">
            <ng-template #list>
                <spike-organization-list #listRef
                [modelApi]="vehicleModelApi"
                [entityApi]="vehicleApi"
                [etiquetteApi]="vehicleEtiquetteApi"
                entityKey="vehicleId">
                </spike-organization-list>

            </ng-template>
        </spike-field-select>
        }
        <spike-field-number label="Numero Colli" formControlName="parcel" suffix=" colli"> </spike-field-number>
        <spike-field-number label="Peso Totale (kg)" formControlName="weight" suffix=" kg"></spike-field-number>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-4 gap-4 mb-4">
        <spike-field-date label="Data Spedizione" formControlName="sendDate"></spike-field-date>
        <spike-field-date label="Data Consegna" formControlName="deliveryDate"></spike-field-date>
    </div>

    <spike-field-text-area label="Note Spedizione / Istruzioni Consegna" formControlName="description"></spike-field-text-area>
</form>
}